import $i18n from 'panda-i18n';
import React, { useContext, useState } from 'react';
import { CnDialogFullpage } from '@/components/cn-dialog-fullpage';
import { CnButtonGroup } from '@/components/cn-button-group';
import { CnButton } from '@/components/cn-button';
import { CnCard } from '@/components/cn-card';
import { useItemButtons } from '../../hooks/use-item-buttons';
import { ItemCard } from '../item-card';
import { ItemForm } from '../item-form';
import { CardItemsStateCtx } from '../../context/card-items';
/** 列表项 */
export const Item = (props) => {
    const { rowIndex, data } = props;
    const buttons = useItemButtons(props);
    const [visible, setVisible] = useState(false);
    const { disableDetail } = useContext(CardItemsStateCtx);
    return (React.createElement(React.Fragment, null,
        React.createElement(ItemCard, { rowIndex: rowIndex, data: data, footAction: { buttons }, onClick: disableDetail
                ? undefined
                : (event) => {
                    setVisible(true);
                    event.preventDefault();
                    event.stopPropagation();
                } }),
        disableDetail ? null : (React.createElement(CnDialogFullpage, { zIndex: 299, title: $i18n.get({
                id: '31255239428542464.CNTM',
                dm: '详情',
                ns: 'CnCardItems',
            }), visible: visible, onClose: () => setVisible(false), footer: buttons.length ? (React.createElement(CnButtonGroup, { isReverse: true, size: "large", fullWidth: true }, buttons.map(({ children, ...item }, i) => (React.createElement(CnButton, { ...item, key: `${Date.now() + i}` }, children))))) : (false) },
            React.createElement(CnCard, null,
                React.createElement(ItemForm, { rowIndex: rowIndex, data: data }))))));
};
